import { render, staticRenderFns } from "./Shared.vue?vue&type=template&id=3208a613"
import script from "./Shared.vue?vue&type=script&lang=ts"
export * from "./Shared.vue?vue&type=script&lang=ts"
import style0 from "./Shared.vue?vue&type=style&index=0&id=3208a613&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3208a613')) {
      api.createRecord('3208a613', component.options)
    } else {
      api.reload('3208a613', component.options)
    }
    module.hot.accept("./Shared.vue?vue&type=template&id=3208a613", function () {
      api.rerender('3208a613', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statics/Shared.vue"
export default component.exports